import { BalanceCell } from '../../../../../../reports/elements/BalanceCell'
import { BALANCE_COLUMNS } from '../../constants/balanceColumns'
import { TrialBalanceTableRow } from '../../types/tableTypes'
import { getBalanceByType } from '../../utils/getBalanceByType'

interface BalanceCellsProps {
  row: TrialBalanceTableRow
  periodQuery?: string
}

export const BalanceCells = ({ row, periodQuery }: BalanceCellsProps) => {
  return (
    <>
      {BALANCE_COLUMNS.map((col) => {
        const balance = getBalanceByType(row.balances, col.key) || 0
        return (
          <BalanceCell
            balance={balance}
            balanceType={col.key}
            periodQuery={periodQuery}
            type={row.type}
            id={row.originalId || row.id}
          />
        )
      })}
    </>
  )
}
